import { apiGet, GetManageTeamConsulteesResponse } from 'api';

export const getManageTeamConsultees = (): Promise<GetManageTeamConsulteesResponse> =>
  apiGet<GetManageTeamConsulteesResponse>('parentOrganisationConsultees');
